import { gql } from "@apollo/client";
import { API_URL } from "services/config";
export const FIELDS = `id idGenerador idTransportista idOperador idAnterior numero estado anio idConfiguracion datos snapshot intervenciones createdAt archivos { id nombre tipo } acciones`;
export const OPTIONS = gql`
  query {
    manifiestoOpciones
    residuos {
      id
      item
      descripcion
    }
    tratamientos {
      id
      item
      descripcion
    }
    manifiestoConfiguracionVigente {
      id
      referencia
      organismo
      normativa
      declaracion
    }
  }
`;
export const LIST = gql`
  query (
    $page: Int
    $search: String
    $estado: String
    $anio: Int
    $idEmpresa: ID
    $actividad: String
    $pendientes: Boolean
  ) {
    manifiestos(
      page: $page
      search: $search
      estado: $estado
      anio: $anio
      idEmpresa: $idEmpresa
      actividad: $actividad
      pendientes: $pendientes
    ) {
      total
      items {
        id
        numero
        estado
        idGenerador
        idTransportista
        idOperador
        createdAt
        acciones
      }
    }
  }
`;
export const DETAIL = gql`query($id:ID!) { manifiesto(id:$id) { ${FIELDS} } }`;
export const SAVE = gql`
  mutation ($input: ManifiestoBorradorInput!) {
    guardarManifiestoBorrador(input: $input) {
      id
    }
  }
`;
export const ACTIONS = {
  PRESENTAR: "presentarManifiesto",
  ACEPTAR: "aceptarManifiesto",
  DESPACHO: "certificarDespachoManifiesto",
  TRASLADO: "confirmarTrasladoManifiesto",
  RECEPCION: "confirmarRecepcionManifiesto",
  DISPOSICION: "confirmarDisposicionManifiesto",
  CERRAR: "cerrarManifiesto",
  RECHAZAR: "rechazarManifiesto",
  ANULAR: "anularManifiesto",
};
export const LABELS = {
  PRESENTAR: "Presentar",
  ACEPTAR: "Aceptar asignación",
  DESPACHO: "Certificar despacho",
  TRASLADO: "Confirmar traslado",
  RECEPCION: "Confirmar recepción",
  DISPOSICION: "Confirmar disposición",
  CERRAR: "Confirmar declaración final",
  RECHAZAR: "Rechazar",
  ANULAR: "Anular",
};
export function actionMutation(action) {
  const role = ["ACEPTAR", "RECHAZAR"].includes(action);
  return gql`mutation($id:ID!,$input:ManifiestoConfirmacionInput!${
    role ? ",$actividad:String!" : ""
  }) { ${ACTIONS[action]}(id:$id,input:$input${role ? ",actividad:$actividad" : ""}) { id } }`;
}
export async function documentBlob(tipo, id) {
  const token = JSON.parse(localStorage.getItem("user") || "{}").token || "";
  const response = await fetch(`${API_URL}/manifiestos-archivos/${tipo}/${id}`, {
    headers: { Authorization: token },
  });
  if (!response.ok) throw Error("No se pudo descargar el documento");
  return response.blob();
}
export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
export async function download(tipo, id, name) {
  saveBlob(await documentBlob(tipo, id), name);
}
